import { StrictMode, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useSession } from "@descope/react-sdk";
import { createRouter, RouterProvider } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen.ts";
import './index.css'
import { GlobalErrorBoundary, PlatformAuthProvider } from "@nxt-platform/global-components";
import { ToastProvider } from '@nxt-shared/ui/components/Toast';
import { client } from './api/client.gen.ts';

const queryClient = new QueryClient()

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Keep the generated tenant-backend client authenticated with the live Descope session token.
// baseUrl "" → same-origin (apps.<domain>/management/api in prod; the Vite proxy in dev).
function ApiClientProvider({ children }: { children: React.ReactNode }) {
  const { sessionToken } = useSession()

  useEffect(() => {
    client.setConfig({
      auth: sessionToken,
      baseUrl: "",
    })
  }, [sessionToken])

  return <>{children}</>
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <GlobalErrorBoundary>
        <PlatformAuthProvider>
          <ApiClientProvider>
            <QueryClientProvider client={queryClient}>
              <ToastProvider>
                <RouterProvider router={router} />
              </ToastProvider>
            </QueryClientProvider>
          </ApiClientProvider>
        </PlatformAuthProvider>
      </GlobalErrorBoundary>
    </StrictMode>,
  )
}
